import React from 'react';
import { backButtonIcon, diamondIcon, search, searchD, userIcon} from 'assets/utils/images';
import { Dropdown } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import BrowserService from 'service/browser.service';

const activePath = {
    "/profile-update": "1",
    "/password-change": "2",
    "/logout": "3",
}

const Header = ({
    breadcrumb = []
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const user = localStorage.getItem("authDetails");

    const items = [
        {
            key: '1',
            label: (
                <span className='w-full flex px-[12px] py-[5px]' onClick={() => navigate("/profile-update")}>Profile Update</span>
            ),
        },
        {
            key: '2',
            label: (
                <span className='w-full flex px-[12px] py-[5px]' onClick={() => navigate("/password-change")}>Password Change</span>
            ),
        },
        {
            key: '3',
            label: (
                <span className='w-full flex px-[12px] py-[5px] text-[#ef4444]' onClick={() => handleLogout()}>Logout</span>
            ),
        },
    ];

    const backPath = location.state?.backPath || null;
    const backState = location.state?.backState || null;

    const handleBack = () => {
        if (backPath) {
            navigate(backPath);
        } else {
            navigate(-1); // fallback if no specific path given
        }
    };

    function handleLogout() {
        localStorage.removeItem("authDetails");
        BrowserService.removeCookie("token");
        setTimeout(() => navigate("/login"), 50);
    }

    return (
        <header className="w-full h-[68px] flex items-center px-[20px] border-b border-[rgba(0,0,0,0.1)]">
            <div className="flex w-full justify-between items-center">
                {
                    breadcrumb.length &&
                    <div className="hidden items-center md-2:flex">
                        {
                            breadcrumb.length > 2 && (
                                <button
                                    onClick={handleBack}
                                    className="text-[15px] text-blue-500 font-medium mr-[16px] hover:underline"
                                >
                                    <img
                                        src={backButtonIcon}
                                        alt="Back"
                                        className="w-[40px] h-[40px]"
                                    />
                                </button>
                            )
                        }
                        {
                            breadcrumb.map((crumb, index) => (
                                <>
                                    <span key={index} className="text-[15px] font-medium text-[--light-black] mr-[16px]">{crumb}</span>
                                    {index < breadcrumb.length - 1 && <span className="text-[15px] font-medium text-[--light-black] mr-[16px]">/</span>}
                                </>
                            ))
                        }
                    </div>
                }

                <Dropdown
                    menu={{
                        items,
                        selectable: true,
                        defaultSelectedKeys: [activePath[location.pathname]],
                    }}
                    placement="bottomRight"
                >
                    <div className='flex items-center cursor-pointer'>
                        <img
                            src={JSON.parse(user)?.profilePic
                                ? `${process.env.REACT_APP_IMAGE_URL}${JSON.parse(user)?.profilePic}`
                                : diamondIcon}
                            alt="userIcon"
                            className="w-[40px] h-[40px] cursor-pointer border border-[rgba(0,0,0,0.1)] rounded-[50%] object-cover"
                            onError={(e) => { e.target.src = diamondIcon; }}
                        />
                        <div className='ml-[10px] flex flex-col'>
                            <span className='text-[15px] font-medium text-[black]'>{JSON.parse(user)?.fullName ?? ''}</span>
                            <span className='text-[13px] text-[--light-black]'>{JSON.parse(user)?.userType ?? ''}</span>
                        </div>
                    </div>
                </Dropdown>
            </div>
        </header>
    );
};

export default Header;